import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  localDeliveryShipDateNotAppliedInfo: {
    defaultMessage: 'Ship Date selection will not apply to Local Delivery bookings.',
    id: 'j2CUjG',
    description: 'Local Delivery Info Message; Ship Date not Applied',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'qaq4Aq',
    description: 'costReviewModal.cancel',
  },
  continue: {
    defaultMessage: 'Continue',
    id: '0mEen7',
    description: 'costReviewModal.continue',
  },
  costReviewTitle: {
    defaultMessage: 'Label Batch Status: Cost Review',
    id: '9soQyC',
    description: 'batchProcessingModal.costReviewTitle',
  },
  autoBatchSplittingWarning: {
    defaultMessage:
      'This batch contains orders shipping from {count} different locations. Separate batches will be created for each location.',
    id: '1+QGpC',
    description: 'batchProcessingModal.costReviewTitle',
  },
  applySavings: {
    defaultMessage: 'Apply Savings',
    description: 'Text for button to apply selected savings recommendations',
    id: 'KjiDGE',
  },
});
